var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"footer fixed"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("首页")])],1),_c('li',{on:{"click":_vm.handleCheckedCitiesChange}},[_c('router-link',{attrs:{"to":"/manage"}},[_vm._v("列表")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }